import { selectViewers } from "features/pubsub/slice"
import store, { socket } from "integrations/redux/store"

export const updateLiveChat = ({
    message,
    projectId,
    userId,
}: {
    message: string
    projectId: string
    userId: string
}) => {
    const viewers = selectViewers()(store.getState())
    if (viewers.length > 0) socket?.emit("liveChat", projectId, userId, message)
}
